import React from 'react'
import { Col } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

const ReusableLatestBlog = ({img}) => {
  return (
    <>
    <Col lg={4} md={6}>
      <Card className='latest_blog_main' >
        <Card.Img variant="top" src={img}  class="w-100"/>
        <Card.Body className='latest_blog_text'>
          <Card.Title> 
            <ul>
              <li> <p><i class="fa-regular fa-user"></i>By admin</p></li>
              <li> <p><i class="fa-solid fa-tag"></i>By admin</p></li>
            </ul>
          </Card.Title>
          <Card.Title>
           <h2>How and when to replace <br/>brake rotors</h2>
          </Card.Title>
        </Card.Body>
        <ListGroup >
          <div class="latest_blog_text_main_icon">
            <p><i class="fa-regular fa-calendar"></i>June 24, 2021</p>
           <Card.Link className='latest_blog_text_main_button' href="#">Read more</Card.Link>
          </div>
        </ListGroup>
      </Card>
    </Col>
    </>
  )
}

export default ReusableLatestBlog

